module.exports = __webpack_public_path__ + "static/media/emblem_black.94e910c5.png";